import { Component, inject } from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

export interface InfoDialogConfig {
  title: string;
  message: string;
}

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: 'info-dialog.html',
  imports: [
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
  ],
})
export class InfoDialog {
  readonly dialogRef = inject(MatDialogRef<InfoDialog>);
  readonly data = inject<InfoDialogConfig>(MAT_DIALOG_DATA);
  readonly sanitiser = inject(DomSanitizer);

  public signupSuccessText: SafeHtml = this.sanitiser.bypassSecurityTrustHtml(this.data.message)

}
